const svgPaths = {
  p5117980:
    "M1753 282.896V411.544V459.28H0V411.544V73.5858C24.0515 60.6433 49.061 49.0713 75.2973 39.2485C252.341 -27.1277 439.526 -4.05371 600.911 69.0887C685.16 107.395 760.877 157.288 836.366 207.03C937.531 273.691 1038.28 340.079 1158.6 377.944C1230.39 400.476 1301.54 411.507 1370.75 411.544H1371.44C1504.93 411.472 1631.09 370.472 1740.38 292.154C1744.6 289.127 1748.81 286.04 1753 282.896Z",
};

export default svgPaths;